// extracted by mini-css-extract-plugin
export default {"host-stock-promo__container":"styles_host-stock-promo__container__pfvyF"};